import { DraftFormPopupContainer } from '../../../Draft'
import {
  useRentalPortalApplicantDraft,
  useRentalPortalApplicantFormCloseConfirmation,
} from '../RentalPortalApplicants.hooks'

function RentalPortalApplicantFormPopupContainer({
  title,
  onClose,
  onSubmitConfirm,
  ...containerProps
}) {
  const { getLatestDraft, setDraft } = useRentalPortalApplicantDraft()

  const { Confirmation, handleSubmitConfirm } =
    useRentalPortalApplicantFormCloseConfirmation({ onClose, onSubmitConfirm })

  return (
    <DraftFormPopupContainer
      {...containerProps}
      Confirmation={Confirmation}
      getLatestDraft={getLatestDraft}
      setDraft={setDraft}
      titleKey={title}
      onClose={onClose}
      onSubmitConfirm={handleSubmitConfirm}
    />
  )
}

export default RentalPortalApplicantFormPopupContainer
